import { ProcessRespondentSelectionCriterionType } from './../models/process-models';
import { Observable ,  Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ConfirmationRespondentService {
  myTeamSurveyTabClicked$: Observable<boolean>;
  myPageEstimateTabClicked$: Observable<boolean>;
  myBuSurveyTabClicked$: Observable<boolean>;
  

  private myTeamSurveyTabClickSubject: Subject<boolean> = new Subject<boolean>();
  private myPageEstimateTabClickSubject: Subject<boolean> = new Subject<boolean>();
  private myBuSurveyTabClickSubject: Subject<boolean> = new Subject<boolean>();
    constructor(private readonly translateService: TranslateService) {
      this.myTeamSurveyTabClicked$ = this.myTeamSurveyTabClickSubject.asObservable();
      this.myPageEstimateTabClicked$ = this.myPageEstimateTabClickSubject.asObservable();
      this.myBuSurveyTabClicked$  = this.myBuSurveyTabClickSubject.asObservable();
    }

    getSelectionColumnTranslation(selectionType: ProcessRespondentSelectionCriterionType): Observable<any> {
        const translationKey = this.getSelectionColumnTranslationKey(selectionType);
        return this.translateService.get(translationKey);
    }

    myTeamSurveyTabClick(surveyTabValue: boolean) {
      this.myTeamSurveyTabClickSubject.next(surveyTabValue);
    }

    myPageEstimateTabClick(surveyTabValue: boolean) {
      this.myPageEstimateTabClickSubject.next(surveyTabValue);
    }

    myBuSurveyTabClick(surveyTabValue: boolean) {
      this.myBuSurveyTabClickSubject.next(surveyTabValue);
    }

    private  getSelectionColumnTranslationKey(selectionType: ProcessRespondentSelectionCriterionType): string {
        switch (selectionType) {
          case ProcessRespondentSelectionCriterionType.GradeBelowRespondentMinAmount:
            return 'lang.approval.gradeBelowRespondent';
          case ProcessRespondentSelectionCriterionType.GradeEqualRespondentMinAmount:
            return 'lang.approval.gradeEqualRespondent';
          case ProcessRespondentSelectionCriterionType.GradeAboveRespondentMinAmount:
            return 'lang.approval.gradeAboveRespondent';
          case ProcessRespondentSelectionCriterionType.TeamMinAmount:
            return 'lang.approval.teamRespondents';
          case ProcessRespondentSelectionCriterionType.OtherRespondentMinAmount:
            return 'lang.approval.otherRespondent';
          default:
            break;
        }
      }
}
